import type { definitions } from '@luxuryescapes/contract-trip'

// Derive savedItemData directly from the dayTripItem schema definition.
// This guarantees the full source union ('offer' | 'spp' | ...) regardless
// of how deeply-nested path-indexed types resolve in different TS environments.
type DayTripSavedItemData = NonNullable<definitions['dayTripItem']['savedItemData']>

type ContractOfferSavedData = Extract<DayTripSavedItemData, { source: 'offer' }>
type ContractSppSavedData = Extract<DayTripSavedItemData, { source: 'spp' }>

// contract-trip exposes memberPrice on the server response but the generated
// types don't surface it on the narrowed Extract variants. Extend here so all
// consumers can access the fields without casting.
type MemberPriceFields = { memberPrice?: number; memberDiscountPercent?: number }
export type OfferSavedData = ContractOfferSavedData & MemberPriceFields
export type SppSavedData = ContractSppSavedData & MemberPriceFields
export type ExperienceSavedData = Extract<DayTripSavedItemData, { source: 'offer_experience' }>
export type HotelSavedData = OfferSavedData | SppSavedData

const HOTEL_SOURCES: ReadonlySet<string> = new Set(['offer', 'spp'])

export function isHotelSavedData(
  data: DayTripSavedItemData | null | undefined,
): data is HotelSavedData {
  return data != null && HOTEL_SOURCES.has(data.source)
}

export function isSppSavedData(data: HotelSavedData): data is SppSavedData {
  return data.source === 'spp'
}

export function isExperienceSavedData(
  data: DayTripSavedItemData | null | undefined,
): data is ExperienceSavedData {
  return data?.source === 'offer_experience'
}
